// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Message = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Message = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Message = _exports.Message = function Message(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.5769 2H3.42308C2.781 2.00187 2.16574 2.26367 1.71172 2.7282C1.2577 3.19272 1.00183 3.82223 1 4.47917V12.9792C1.00183 13.6361 1.2577 14.2656 1.71172 14.7301C2.16574 15.1947 2.781 15.4565 3.42308 15.4583H5.15385V19L9.20904 15.5407C9.27131 15.4875 9.34987 15.4583 9.43101 15.4583H16.5769C17.219 15.4565 17.8343 15.1947 18.2883 14.7301C18.7423 14.2656 18.9982 13.6361 19 12.9792V4.47917C18.9982 3.82223 18.7423 3.19272 18.2883 2.7282C17.8343 2.26367 17.219 2.00187 16.5769 2Z",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linejoin": "round"
    }));
  };
});
